import Api from '@/api/api'

export default {
  login(data) {
    return Api().post('auth/login', data)
  },
  verify(data) {
    return Api().post('auth/verify', data)
  },
  selectBuilding(data) {
    return Api().post('auth/select-building', data)
  },
  demo() {
    return Api().post('auth/demo')
  },
}
